import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    mobileContainer: 'h-full w-full max-lg:container',
    base: 'flex h-full w-full flex-col bg-white md:p-6 lg:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.07)]',
    title: 'heading-xl hidden md:flex',
    pointTypeSelector: 'relative mb-3 md:mt-3 md:mb-4',
    pointsScrollWrapper: 'h-full overflow-y-auto contain-strict',
    pointsScrollInner: 'relative w-full',
    pointList: 'absolute top-0 left-0 w-full',
    pointItemContainer:
      'hover:bg-surface w-full border-t-[1px] border-black pt-2 first:border-0 first:pt-0',
    pointItem:
      'bg-bg-items-white/40 w-full cursor-pointer p-5 text-left transition-colors',
    pointTitle: 'heading-m-bold',
    pointAddress: 'heading-s mt-2',
    pointCost: 'heading-s mt-2',
    pointDeliveryDate: 'heading-s mt-1',
    pointHeading: 'heading-s mt-3',
    pointValue: 'heading-s mt-2',
    pointConfirm: 'mt-5 w-full',
    emptyState: 'text-m',
    option: 'flex items-center gap-2.5'
  },
  variants: {
    withMargin: {
      true: {
        title: 'mb-5'
      }
    },
    size: {
      small: {
        base: 'lg:w-80 xl:p-6'
      },
      default: {
        base: 'lg:w-100 xl:w-105 xl:p-5'
      }
    },
    isActive: {
      true: {
        pointItem: 'bg-bg-items-white',
        pointItemContainer: 'bg-surface'
      }
    }
  }
});
